import * as angular from 'angular';
import * as moment from 'moment';

import { TicketViewModel } from '../../models';
import { guidEmpty } from '../../common/';
import { IAuthenticationService } from '../../services/general';

export interface IticketColoringService {
    getClass(vm: TicketViewModel): { [className: string]: boolean };
}

export class TicketColoringService implements IticketColoringService {
    static serviceId = 'ticketColoringService';
    
    static $inject = ['authenticationService'];
    constructor(private _authenticationService: IAuthenticationService) {
    }

    getClass(vm: TicketViewModel): { [className: string]: boolean } {
        const { model } = vm;
        const dueDate = moment(model.revisedDueDate ?? model.dueDate);
        const beginDay = moment().startOf('d');// TODO account for application configuration
        const diff = dueDate.diff(beginDay, 'd');
        const classed = {};
        const danger = 'ticket-danger';
        const warn = 'ticket-warning';
        const info = 'ticket-info';
        if (diff < 0) {
            classed[danger] = true;
        }
        else if (diff <= 3) {
            classed[warn] = true;
        } else if (model.assignedUser === guidEmpty || !model.assignedUser) {
            classed[warn] = true;
        } else if (model.assignedUser === this._authenticationService.authentication.userGuid) {
            classed[info] = true;

        }
        return classed;
    }
}